// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"94d82fb1","77":"a74d03a4","115":"a66fb7a3","222":"266f8fd5","280":"c0918b89","354":"92c158cb","444":"f9db5d39","523":"15167719","526":"0d387a3e","567":"e7f4c384","850":"5a3b4af5","860":"f69de533","928":"d979bf35"}[chunkId] + ".chunk.js";
};